import { SetLog, TagLogs } from "../../../logs/set-log";
/**
 * 
 * @param {*} body data query params
 * @param {*} oper str -> 'update'|'create'
 * @returns 
 */
export async function getQueryString(body, oper = 'create', pipeType, oldLeadFields) {
  let result = '';
  try {
    const accepteds = await filterBody(body, pipeType);
    const bodyKeys = Object.keys(accepteds);
    // console.log({ accepteds, bodyKeys });

    let field;
    bodyKeys.forEach((param) => {
      field = getQuery(param, accepteds[param], oldLeadFields);
      if (field) {
        if (oper === 'update') {
          result += `,{fieldId: "${param}" value: ${field} }`;
        } else {
          result += `,{field_id: "${param}", field_value: ${field}}`;
        }
      }
    });

    if (result == '') {
      return result;
    }

    return result.slice(1);
  } catch (error) {
    SetLog(TagLogs.dispath_hook, { data: 'PIPEFY Falhou', details: { error: error.message } }, false);

    return '';
  }
}

export const FIELDS_LEAD_PIPEFY = {
  celular: "n_mero_de_telefone",
  celular_txt: "telefone",
  campanha: "campanha",
  campanha_txt: "campanha_texto",
  municipio: "cidade",
  estado: "estado",
  valor_medio_mensal_da_conta: "valor_da_conta_de_luz",
  concessionaria_texto: "concessionaria_texto",
  usina_texto: "usina_texto",
  disponibilidade_atendimento: "disponibilidade_atendimento",// Sim/Não
  tipo_conta: "tipo_do_cliente", //"Geração Distribuída"/"Mercado Livre de Energia"
  tipo: "para_sua_casa_ou_para_seu_neg_cio",
  assessor: "acessores",
  json_form: "json", //??
  sms_confirmed: "c_digo_validado", // código do sms ?
  nome_contrato: "nome", // Tem nome / sobrenome e nome_contrato /contratar/desconto-usinas/formulario-novajornada
  email: "email",
  taxvat_contrato_pf: "cpf", //cpf e cnpj é o mesmo campo taxvat_contrato não existe distinção
  taxvat_contrato_pj: "cnpj",
  estado_civil: "sele_o_de_lista", //??
  profissao: "profiss_o",
  cep_contrato: "cep",
  endereco_contrato: "rua",
  numero_endereco_contrato: "n_mero",
  complemento_endereco_contrato: "complemento",
  completou_fluxo: "completou_o_fluxo_webapp",    // Na tela dados-form-enviados e na tela confirme-dados-form não consta envio desta confirmação
  logou_na_plataforma: "clicou_cta_entrar",
  clicou_esqueceu_senha: "clicou_cta_esqueceu_senha",              // Procurei na /usuario/entrar e usuario/password-reset e não tem envio de dados
  nova_senha_inserida: "nova_senha_inserida_clicoucta_atualizar",
  nome_form: "nome_1",
  email_form: "email_1",
}

/**
 * Filtra os campos recebidos para serem compatíveis com os campos integrados na ferramenta
 * @param {*} body {} -> array de keyValues a ser enviado
 * @param {*} type str -> "data"|"step" -> atualizar dados do lead ou comportamentos do lead
 */
async function filterBody(body, type) {

  const pipeKeys = FIELDS_LEAD_PIPEFY;

  const acceptKeys = Object.keys(pipeKeys);
  let bodyKeys = Object.keys(body);
  // filtrando valores recebidos no body pelos aceitos na sharp
  let acceptedKeys = bodyKeys.filter((item) => acceptKeys.includes(item));
  let lead = {};

  acceptedKeys.map((item) => {
    lead[pipeKeys[item]] = body[item];
  });

  return lead;
}

function getQuery(field, value, oldLeadFields) {

  const fields = FIELDS_LEAD_PIPEFY;

  if (!value) {
    // Campo não foi preenchido
    return false;
  }

  switch (field) {
    // Campos de seleção múltipla: database ou checklist
    case fields.clique_cta_usina_listing_pipe:
    case fields.clique_cta_usina_listing_nome:
    case fields.clique_cta1_card_usina_listing_nome:
    case fields.clique_cta2_card_usina_listing_nome:
      return getQueryRelationAddedListing(field, value, oldLeadFields);

    // Campo que determina o tipo de conta - PF ou PJ
    case fields.tipo_conta:
      return value == 'pf' ? `"Para sua casa"` : `"Para seu negócio"`;
    default: return `"${value}"`;
  }

}

function getQueryRelationAddedListing(field, value, oldLeadFields) {
  // Recuperando dados atuais do campo
  try {

    const oldValue = oldLeadFields.filter(dataField => dataField?.field?.id == field)?.[0] ?? [];
    if(!oldValue.array_value) {
      // Campo vazio - default
      oldValue.array_value = [];
    }
    if (oldValue.array_value?.length == 0) {
      // Outra possibilidade de campo vazio - usuário pipefy removeu manualmente ou fez alguma alteração
      oldValue.array_value = [value?.trim()];
    } else if (!oldValue.array_value?.includes(value?.trim())) {
      oldValue.array_value.push(value?.trim());
    }
    // Verificando se value é number: caso seja, consideramos que o array seja de numbers
    // montando string com valores atuais
    const newValue = isArrayOfNumbers(oldValue.array_value) ? `[${oldValue.array_value?.join(',') ?? ''}]` : `["${oldValue.array_value?.join('","') ?? ''}"]`;

    return newValue;
  }catch(err) {
    console.log({err: err.message})
  }
}

/**
 * TRUE | FALSE - if is array of numbers
 * @param {*} arr 
 */
const isArrayOfNumbers = (arr) => {
  let flagIsNumber = true;

  arr.map(item => {
    if (isNaN(parseInt(item))) {
      flagIsNumber = false;
    }
  });

  return flagIsNumber;
}